import { Feature } from 'ol';
import Geometry from 'ol/geom/Geometry';
import { IAtributo, ILayers } from 'contexts/@types/Layers';

export function getVectorLayerAttributes(layer: Pick<ILayers, 'atributos' | 'vector_source'>): IAtributo[] {
  if (layer.atributos && layer.atributos.length > 0) return layer.atributos;

  const source = layer.vector_source;
  if (!source) return [];

  const features = source.getFeatures() as Feature<Geometry>[];
  if (features.length === 0) return [];

  const fieldNames = new Set<string>();
  const sampleValues: Record<string, unknown> = {};

  features.forEach((feature) => {
    const props = { ...feature.getProperties() } as Record<string, unknown>;
    delete props.geometry;

    Object.keys(props).forEach((key) => {
      fieldNames.add(key);

      if (sampleValues[key] === undefined && props[key] !== undefined && props[key] !== null) {
        sampleValues[key] = props[key];
      }
    });
  });

  return Array.from(fieldNames).map((name) => ({
    nm_coluna: name,
    nm_alias: name,
    visivel: true,
    ds_tipo: guessAttributeType(sampleValues[name]),
  }));
}

export function guessAttributeType(value: unknown): string {
  if (value === null || value === undefined) return 'Texto';
  if (typeof value === 'number') return 'Número';
  if (typeof value === 'boolean') return 'Texto';
  if (value instanceof Date) return 'Data';

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') return 'Texto';

    const isIsoDate = /^\d{4}-\d{2}-\d{2}/.test(trimmed);
    const isBrDate = /^\d{2}\/\d{2}\/\d{4}$/.test(trimmed);

    if ((isIsoDate || isBrDate) && !Number.isNaN(Date.parse(trimmed))) {
      return 'Data';
    }

    return 'Texto';
  }

  return 'Texto';
}
